import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

interface LoadingOverlayProps {
  active: boolean;
  text?: string;
  children?: React.ReactNode;
  overlayBg?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  active,
  text,
  children,
  overlayBg = 'rgba(255, 99, 71, 0)', // same as old version
}) => {
  return (
    <Box position="relative">
      {children}
      {active && (
        <Box
          data-testid="loading-overlay"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: overlayBg,
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress
            sx={{
              '& circle': {
                stroke: '#002f52',
                strokeWidth: 3,
              },
            }}
          />
          {text && (
            <Typography mt={2} sx={{ fontSize: '20px', fontFamily: 'Arial', color: '#002f52' }}>
              {text}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
